import React, { useContext } from 'react';

import { useAppSelector } from '../../store';
import craftJsParser from '../../components/utils/craftJsParser';
import { DataElementContext } from '../common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';
import { useMediaQuery } from '@/components/utils/useQueryMedia';
import { PageDataContext, getProjectDataFromContext } from '../../components/utils/PageDataProvider';
import { buildLayoutBuilder } from './utils/functions';

export const LayoutBuilder = (componentProps) => {
  let props = componentProps;

  const dataElementContext = useContext(DataElementContext);
  const pageDataContext = useContext(PageDataContext);
  const authenticated = useAppSelector(
    (state) => (state.authentication && state.authentication.auth_type === 'user'),
  );

  const isTablet = useMediaQuery(`(min-width: ${window.config.breakpointTablet})`);
  const isDesktop = useMediaQuery(`(min-width: ${window.config.breakpointDesktop})`);
  const breakpoints = React.useMemo(() => ({ isTablet, isDesktop }), [isTablet, isDesktop]);

  let isVisible = true;
  [props, isVisible] = processComponentProps(props, dataElementContext, breakpoints);


  const { hasError, content } = React.useMemo(() => {
    let content = null;
    let hasError = false;

    try {
      const data = getProjectDataFromContext(pageDataContext);

      const rootNodeId = props.id;

      const parsed = buildLayoutBuilder(rootNodeId, props.properties.layout, props.properties.layouts, data);

      if (parsed.success) {
        content = craftJsParser({
          craftState: parsed.data.content,
          rootNodeId: 'ROOT',
          pageId: props.refType === 'layout' ? null : props.refId,
          pageLayoutId: props.refType === 'layout' ? props.refId : null,
          pageType: props.refType,
          options: {
            authenticated,
          },
        });
      }

    } catch (err) {
      console.error(err);
      hasError = true;
    }

    return { hasError, content };
  }, [props.id, props.properties.layout, props.properties.layouts, authenticated, pageDataContext, props.refType, props.refId]);

  if (hasError) return null;
  if (!content) return null;
  if (!isVisible) return null;

  return content;
};
